const contactfinder = document.querySelector('#contact-app');

if (contactfinder !== null) {
	const detectLanguage = () => {
		const url = window.location.href;
		if (url.includes('lang=en') || url.includes('/en')) return 'en';
		if (url.includes('lang=fr') || url.includes('/fr')) return 'fr';
		if (url.includes('lang=it') || url.includes('/it')) return 'it';
		return 'de';
	}

	const i18n = new VueI18n({
		locale: detectLanguage(),
		messages: {
			en: {
				"concern": 'Concern',
				"area": 'Area',
				"choose": 'Choose',
				"tariff_area": 'Tariff Area',
				"region": 'Region',
				"contact_search": 'Find Contact',
				"show_more": 'Show more',
				"no_data": 'No data',
				"contactfinder.title": "Contact Finder",
				"contactfinder.subtitle": "Are you looking for your contact person for contracts, permits and determinations?",
				"selectconcern": "Please select a concern.",
				"selectarea": "Please select an area.",
				"selecttariff": "Please select a tariff.",
			},
			de: {
				"concern": 'Anliegen',
				"area": 'Bereich',
				"choose": 'Wählen',
				"tariff_area": 'Tarifbereich',
				"region": 'Region',
				"contact_search": 'Kontakt finden',
				"show_more": 'Mehr anzeigen',
				"no_data": 'Keine Daten',
				"contactfinder.title": "Kontaktfinder",
				"contactfinder.subtitle": "Sie sind auf der Suche nach Ihrem Ansprechpartner bei Verträgen, Genehmigungen und Festsetzungen? Oder haben ein anderes Anliegen?",
				"selectconcern": "Bitte wählen Sie ein Anliegen aus.",
				"selectarea": "Bitte wählen Sie einen Tarifbereich aus.",
				"selecttariff": "Bitte wählen Sie einen Tarif aus.",
			},
			fr: {
				"concern": 'Demande',
				"area": 'Domaine',
				"choose": 'Choisir',
				"tariff_area": 'Domaines tarifaires',
				"region": 'Région',
				"contact_search": 'Recherche de contacts',
				"show_more": 'En savoir plus',
				"no_data": 'Pas de données',
				"contactfinder.title": "Recherche de contacts",
				"contactfinder.subtitle": "Vous êtes à la recherche de votre interlocuteur pour les contrats, les approbations et la procédure de fixation des tarifs ?",
				"selectconcern": "Veuillez sélectionner un sujet.",
				"selectarea": "Veuillez sélectionner un domaine.",
				"selecttariff": "Veuillez sélectionner un domaine tarifaire.",
			},
			it: {
				"concern": 'Richiesta',
				"area": 'Ambito',
				"choose": 'Selezionare',
				"tariff_area": 'Ambito tariffale',
				"region": 'Regione',
				"contact_search": 'Trova contatto',
				"show_more": 'Per saperne di più',
				"no_data": 'Nessun dato',
				"contactfinder.title": "Trova contatto",
				"contactfinder.subtitle": "State cercando il vostro interlocutore per contratti, approvazioni e procedure di fissazione delle tariffe? Oppure ha un’altra richiesta?",
				"selectconcern": "Selezionare una richiesta.",
				"selectarea": "Selezionare un ambito.",
				"selecttariff": "Selezionare un ambito tariffale.",
			}
		}
	});

	new Vue({
		el: '#contact-app',
		i18n,
		data() {
			return {
				staticData: window.staticData,
				anliegenOptions: window.staticData.labels.concern,
				areaOptions: window.staticData.labels.area.filter(area => area.id !== ''),
				regionOptions: window.staticData.labels.cantons,
				tariffArea1Options: window.staticData.labels.tariff_area_1,
				tariffArea2Options: window.staticData.labels.tariff_area_2,
				tariffArea3Options: window.staticData.labels.tariff_area_3,
				contacts: window.staticData.data.contacts,
				entries: window.staticData.data.entries,
				formLabels: window.staticData.labels.form,

				// Selection state
				selectedConcern: null,
				selectedArea: null,
				selectedTariff: null,
				selectedRegion: null,

				// Dropdowns visibility
				dropdownConcernActive: false,
				dropdownAreaActive: false,
				dropdownTariffActive: false,
				dropdownRegionActive: false,

				// Results
				results: [],
				isExpanded: false,
				findContactsClicked: false,

				// Current locale
				currentLocale: 'de',

				concernsThatIncludeArea: [1, 2, 3, 4, 5],
				areasThatIncludeTariff: [1, 2, 3]
			};
		},
		computed: {
			showAreaSelect() {
				return this.concernsThatIncludeArea.includes(this.selectedConcern?.id);
			},
			showTariffSelect() {
				return this.areasThatIncludeTariff.includes(this.selectedArea?.id);
			},
			showRegionSelect() {
				return this.showAreaSelect;
			},
			visibleResults() {
				let temp = this.results.slice(0, 3);
				while (temp.length < 3 && this.results.length > 0) {
					temp.push(null);
				}
				return this.isExpanded ? this.results : temp;
			},
			rows() {
				const r = [];
				for (let i = 0; i < this.visibleResults.length; i += 3) {
					r.push(this.visibleResults.slice(i, i + 3));
				}
				if (r.length && r[r.length - 1].length < 3) {
					while (r[r.length - 1].length < 3) {
						r[r.length - 1].push(null);
					}
				}
				return r;
			}
		},
		mounted() {
			document.addEventListener('click', this.handleClickOutside);
			// we need to detect the language and set it in current locale
			this.currentLocale = detectLanguage();
		},
		beforeDestroy() {
			document.removeEventListener('click', this.handleClickOutside);
		},
		methods: {
			toggleDropdown(type) {
				// Reset all dropdowns first, then toggle the selected one
				// Close all dropdowns first
				this.dropdownConcernActive = false;
				this.dropdownAreaActive = false;
				this.dropdownTariffActive = false;
				this.dropdownRegionActive = false;

				// Then open the clicked dropdown
				switch (type) {
					case 'concern':
						this.dropdownConcernActive = !this.dropdownConcernActive;
						break;
					case 'area':
						this.dropdownAreaActive = !this.dropdownAreaActive;
						break;
					case 'tariff':
						this.dropdownTariffActive = !this.dropdownTariffActive;
						break;
					case 'region':
						this.dropdownRegionActive = !this.dropdownRegionActive;
						break;
				}
			},
			handleClickOutside(event) {
				const dropdowns = [
					this.$el.querySelector('.select'),
					this.$el.querySelector('.area-select'),
					this.$el.querySelector('.tariff-select'),
					this.$el.querySelector('.region-select')
				];
				const isClickInside = dropdowns.some(dropdown => dropdown && dropdown.contains(event.target));

				// If the click is outside of any of the dropdowns, close them
				if (!isClickInside) {
					this.dropdownConcernActive = false;
					this.dropdownAreaActive = false;
					this.dropdownTariffActive = false;
					this.dropdownRegionActive = false;
				}
			},
			findContacts() {
				if (!this.selectedConcern) {
					alert(this.$t('selectconcern'));
					return;
				}
				// if area is not selected, but concern is selected, show alert
				if (!this.selectedArea && this.concernsThatIncludeArea.includes(this.selectedConcern.id)) {
					alert(this.$t('selectarea'));
					return;
				}

				if (this.selectedArea && !this.selectedTariff) {
					alert(this.$t('selecttariff'));
					return;
				}


				const filteredEntries = this.entries.filter(entry => {
					let valid = true;

					if (this.selectedConcern) {
						valid = entry.concern.includes(this.selectedConcern.id);
					}

					if (this.selectedArea) {
						valid = valid && entry.area.includes(this.selectedArea.id);
					}
					if (this.selectedTariff) {
						valid = valid && (
							entry.tariff_area_1.includes(this.selectedTariff.id) ||
							entry.tariff_area_2.includes(this.selectedTariff.id) ||
							entry.tariff_area_3.includes(this.selectedTariff.id)
						);
					}

					if (this.selectedRegion && this.selectedRegion.id !== 'ANY') {
						const entryCantons = entry.canton;
						const selectedId = this.selectedRegion.id;

						// Show only entries that match the selected region or are national
						if (!entryCantons.includes(selectedId) && !entryCantons.includes('ANY')) {
							valid = false;
						}
					}

					return valid;
				});

				let contactsIds = [...new Set(filteredEntries.map(el => el.contacts).flat())]
				let contactResults = [];
				for (let i = 0; i < contactsIds.length; i++) {
					let foundContact = this.contacts.find(contact => contact.id === contactsIds[i]);
					if (foundContact && foundContact.type > 0) {
						contactResults.push(foundContact)
					}
				}

				this.results = contactResults;
				this.isExpanded = false;
				this.findContactsClicked = true;
			},
			showMoreContacts() {
				this.isExpanded = true;
			},
			selectOption(type, value) {
				switch (type) {
					case 'concern':
						this.selectedConcern = value;
						this.dropdownConcernActive = false;
						this.selectedArea = null;
						this.selectedTariff = null;
						this.selectedRegion = null;
						break;
					case 'area':
						this.selectedArea = value;
						this.selectedTariff = null;
						this.selectedRegion = null;
						this.dropdownAreaActive = false;
						break;
					case 'tariff':
						this.selectedTariff = value;
						this.dropdownTariffActive = false;
						this.selectedRegion = null;
						break;
					case 'region':
						this.selectedRegion = value;
						this.dropdownRegionActive = false;
						break;
				}
			},
			getTariffOptions() {
				if (!this.selectedArea) return [];

				switch (this.selectedArea.id) {
					case 1:
						return this.tariffArea1Options;
					case 2:
						return this.tariffArea2Options;
					case 3:
						return this.tariffArea3Options;
					default:
						// set selected tarif to null
						this.selectedTariff = null;
						return [];
				}
			}
		}
	});
}
